import { Button } from '../../components/ui/Button';

/**
 * "Load more" at the foot of a paged list. A failed load keeps what is already on screen and says
 * so under the button, which stays: pressing it again is the retry.
 */
export function LoadMoreButton({
  loading,
  failed,
  onClick,
  size = 'md',
}: {
  loading: boolean;
  failed: boolean;
  onClick: () => void;
  size?: 'sm' | 'md';
}) {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <Button variant="secondary" size={size} loading={loading} onClick={onClick}>
        {loading ? 'Loading…' : 'Load more'}
      </Button>
      {failed && !loading && (
        <p role="alert" className="text-xs text-red-600 dark:text-error-dark">
          Could not load more. Try again.
        </p>
      )}
    </div>
  );
}
